<div *ngIf="surveyEditorService.surveyEditor$().activeQuestion as activeQuestion" [formGroup]="activeQuestion" class="essay-settings__container">
  <div class="essay-settings__input-containers">
    <empathy-required-setting [activeQuestion]="activeQuestion"></empathy-required-setting>
    <empathy-min-view-time-setting [activeQuestion]="activeQuestion"></empathy-min-view-time-setting>
    <div class="essay-settings__input-length-validators">
      <div class="editor-question-form__input">
        <span class="label"> Min response length </span>
        <span class="sublabel"> Set the minimum number of characters required. (Enter 0 for no minimum.) </span>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="minTextLength" />
        </mat-form-field>
      </div>

      <div class="editor-question-form__input">
        <span class="label"> Max response length </span>
        <span class="sublabel"> Set the maximum number of characters allowed. (Enter 0 for no maximum.) </span>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="maxTextLength" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <empathy-media-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-media-settings>
</div>
